import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';

const CompanyEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();
    const [pinCodes, setPinCodes] = useState([]);
    // const companyId = 1;
    // const isSuperAdmin = true;
    // const isAuthenticated = true;
    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId]);

    const [formData, setFormData] = useState({
        Name: '',
        ContactNumber1: '',
        ContactNumber2: '',
        Email: '',
        AddressLine1: '',
        AddressLine2: '',
        GSTNumber: '',
        PanNumber: '',
        Location: '',
        PinCode: '',
        CashOpening: '',
        StockOpening: '',
        PaymentUPIId: '',
        PaymentUPIName: '',
        BToBPrefix: '',
        BToCPrefix: '',
        IGSTPrefix: '',
        FreightGSTRate: '',
        IsEinvoice: '',
        IsEwayBill: '',
        EinvoicePortalUserName: '',
        EinvoicePortalPassword: '',
        myGSTcafeCustomerID: '',
        myGSTcafeApiID: '',
        myGSTcafeApiSecret: '',
        IGSTCustomerPrefix: '',

    });


    const companyid = 1;
    useEffect(() => {
        fetchData('PinCodeApi', `/${companyId}`, token)//, token
            .then((response) => {
                if (response.responseCode == '1111') {
                    setPinCodes(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching PIN codes:', error);
            });
    }, []);



    useEffect(() => {
        fetchData('CompanyApi', `/CompanyDetails/${companyId}`, token)//, token
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Company Details:', error);
            });
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value === 'true' ? true : e.target.type === 'checkbox' ? e.target.checked : value,
        }));
    };


    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: 1,
        }));

        updateData('CompanyApi', `${companyId}`, formData, token)//, token
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    return (

        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Company</h6>

                    <Button
                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                        onClick={handleSubmit}
                    >
                        Update
                    </Button>

                    <Button
                        component={Link}
                        to="/Home"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                    >
                        Cancel
                    </Button>

                </div>

                {/* Render fetched data */}
                <div className="w-full mb-2 flex">
                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="name">
                            Company Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Name' value={formData.Name} onChange={handleChange} type="text" placeholder=" Company name"
                            required
                            maxLength={50}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="contactNumber1">
                            Contact Number 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Contact1' value={formData.Contact1} onChange={handleChange} type="text" placeholder=" Contact Number 1"
                            required
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="contactNumber2">
                            Contact Number 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Contact2' value={formData.Contact2} onChange={handleChange} type="text" placeholder=" Contact Number 2"
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="email">
                            Website
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Website' value={formData.Website} onChange={handleChange} type="text" placeholder=" Website"
                            maxLength={30}
                        />
                    </div>

                </div>

                <div className="w-full mb-2 flex">

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Email' value={formData.Email} onChange={handleChange} type="text" placeholder=" Email"
                            maxLength={30}
                            pattern={emailPattern.source}
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="gstNumber">
                            GST Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='GSTNo' value={formData.GSTNo} onChange={handleChange} type="text" maxLength={15} placeholder=" GST Number" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="gstNumber">
                            Pan Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='PanNo' value={formData.PanNo} onChange={handleChange} type="text" maxLength={15} placeholder=" Pan Number" />
                    </div>

                    <div className="w-1/6 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            Service Tax No
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='ServiceTaxNo' value={formData.ServiceTaxNo} onChange={handleChange} type="text" placeholder=" ServiceTaxNo" />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="email">
                            TIN
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='TIN' value={formData.TIN} onChange={handleChange} type="text" placeholder=" TIN"
                            maxLength={30}
                        />
                    </div>

                </div>

                <div className="w-full mb-2 flex">
                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            Address Line 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Address1' value={formData.Address1} onChange={handleChange} type="text" placeholder=" Address Line 1"
                            maxLength={200}
                            required
                        />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            Address Line 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Address2' value={formData.Address2} onChange={handleChange} type="text" placeholder=" Address Line 2"
                            maxLength={200}
                        />
                    </div>

                </div>
                {/* <div className="w-full mb-2 flex">

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            PinCode
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='PinCode' value={formData.PinCode} onChange={handleChange} type="text" placeholder=" Pin Code" />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            Cash Opening
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='CashOpening' value={formData.CashOpening} onChange={handleChange} type="text" placeholder=" Cash Opening" style={{ textAlign: 'right' }} />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            Stock Opening
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='StockOpening' value={formData.StockOpening} onChange={handleChange} type="text" placeholder=" Stock Opening" style={{ textAlign: 'right' }} />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                            Freight GST Rate
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='FreightGSTRate' value={formData.FreightGSTRate} onChange={handleChange} type="text" placeholder=" Freight GST Rate" style={{ textAlign: 'right' }} />
                    </div>
                </div> */}

            </form >
        </div >

    );
};

export default CompanyEdit;
